export const getLoyaltyConfig = async (loyaltySdk) => {
  try {
    return await loyaltySdk.getConfig();
  } catch {
    return null;
  }
};

export const setCustomerLoyaltyConsent = async (loyaltySdk, consentStatus) => {
  if (!loyaltySdk) {
    return false;
  }

  await loyaltySdk.setCustomerConsent(consentStatus);
  return true;
};

export const hasBenefitAccess = async (loyaltySdk, benefitType) => {
  if (!loyaltySdk) {
    return false;
  }
  try {
    const currentTierId = await loyaltySdk.getCustomerTierId();
    return await loyaltySdk.isBenefitAvailableForTier(
      currentTierId,
      benefitType
    );
  } catch {
    return false;
  }
};

export const getBenefitTypeConfig = (loyaltyConfig, benefitType) => {
  return (
    loyaltyConfig?.benefits?.find((item) => item.type === benefitType) ?? null
  );
};
